import React from 'react'
import User from './User'
import Admin from './Admin'
import Travel from './Travel'
import Finance from './Finance';

export default function Index(){
	let saas = window.location.href.includes('cockpit.dice.tech') || window.location.href.includes('localhost');

	return(
		<div>
			<User/>
			<Admin/>
			{
				saas && <Finance />
			}
			<Travel/>
		</div>
	)
}
